// ------------------------------------
// PÁGINA
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'collections';
    const refEvtPrefix = 'lp-evt-cols-';

    // Altera o título da página
    function changePagTit() {
      const value = confTheme[ref]['pag-title'];
      $('.pag-collections .title').text(value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'pag-title', changePagTit);

    // Altera o grid desktop
    function changeGridDesktop() {
      const value = confTheme[ref]['grid-desktop'];
      $('.bcoll-wrp').removeClass('grid-4 grid-3').addClass(value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'grid-desktop', changeGridDesktop);

    // Altera o grid tablet
    function changeGridTablet() {
      const value = confTheme[ref]['grid-tablet'];
      $('.bcoll-wrp').removeClass('grid-md-6 grid-md-4 grid-md-3').addClass(value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'grid-tablet', changeGridTablet);

    // Altera o grid mobile
    function changeGridMobile() {
      const value = confTheme[ref]['grid-mobile'];
      $('.bcoll-wrp').removeClass('grid-sm-6 grid-xs-6 grid-sm-12 grid-xs-12').addClass(value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'grid-mobile', changeGridMobile);

    // Altera o formato das imagens
    function changeImgFormat() {
      const value = confTheme[ref]['img-format'];
      $('.bcoll, .bcoll-img').removeClass('img-rounded img-square img-circle').addClass(value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'img-format', changeImgFormat);

    // Altera o estilo do bloco
    function changeBoxStyle() {
      const value = confTheme[ref]['box-style'];
      $('.bcoll-wrp').removeClass('infos-inner default').addClass(value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'box-style', changeBoxStyle);

    // Altera a cor do título
    function changeTitColor() {
      const value = confTheme[ref]['tit-color'];
      $('.bcoll-tit').css('color', value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'tit-color', changeTitColor);

    // Exibe/Oculta o botão
    function changeBtnShow() {
      const value = confTheme[ref]['btn-show'];
      if (value == 1) {
        changeColsList();
        $('.bcoll-btn').removeClass('d-none');
      } else {
        $('.bcoll-btn').addClass('d-none');
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'btn-show', changeBtnShow);

    // Altera o estilo do botão
    function changeBtnClass() {
      const value = confTheme[ref]['btn-class'];
      $('.bcoll-btn .btn').removeClass('btn-primary btn-secondary btn-buy btn-white btn-grey').addClass(value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'btn-class', changeBtnClass);

    // Altera o texto do botão
    function changeBtnTxt() {
      const value = confTheme[ref]['btn-txt'];
      $('.bcoll-btn .btn').text(value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'btn-txt', changeBtnTxt);

    // Altera a lista de blocos
    function changeColsList() {
      const list = confTheme[ref]['lista'] || [];
      const $list = $('.collections-list');
      $list.html('');
      if (list && list.length) {
        for (let i = 0; i < list.length; i++) {
          const item = list[i];
          const gridDesktop = confTheme[ref]['grid-desktop'] || 'grid-3';
          const gridTablet = confTheme[ref]['grid-tablet'] || 'grid-md-4';
          const gridMobile = confTheme[ref]['grid-mobile'] || 'grid-sm-12 grid-xs-12';
          const imgFormat = confTheme[ref]['img-format'] || 'img-rounded';
          const boxStyle = confTheme[ref]['box-style'] || '';
          const titColor = confTheme[ref]['tit-color'] || '#333';
          const btnShow = confTheme[ref]['btn-show'] === undefined ? 1 : confTheme[ref]['btn-show'];
          const btnTxt = confTheme[ref]['btn-txt'] || 'Ver produtos';
          const btnClass = confTheme[ref]['btn-class'] || 'btn-primary';
          let $btn = '';
          if (btnShow == 1) {
            $btn = `<div class="bcoll-btn">
              <button class="btn btn-sm ${btnClass}">${btnTxt}</button>
            </div>`;
          }
          $list.append(`<a href="#" class="${gridDesktop} ${gridTablet} ${gridMobile} bcoll-wrp ${boxStyle} img-zoom">
            <div class="bcoll ${imgFormat}">
              <figure class="img ${imgFormat} bcoll-img">
                <img src="${item['img-src']}" alt="${item['img-alt']}" width="100%" height="400px">
              </figure>
              <div class="bcoll-infos">
                <div class="bcoll-tit" style="color: ${titColor}">${item['title']}</div>
                ${$btn}
              </div>
            </div>
          </a>`);
        }
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'blocos-lista', changeColsList);
  }
})();
